import * as Yup from 'yup';

import { Device } from '../models/Device';

const CampaignSchema = (t: (key: string) => string) =>
  Yup.object().shape({
    name: Yup.string().required(t('general_errors.required')),
    description: Yup.string().required(t('general_errors.required')),
    // Switch to device selection instead of drone selection
    device: Yup.mixed<Device>().required(t('general_errors.required')),
    status: Yup.number().required(t('general_errors.required')),
    enable_vantis_send: Yup.boolean().required(t('general_errors.required')),
    dronesense_enabled: Yup.boolean(),
    dronesense_pilot: Yup.number()
      .nullable()
      .when('dronesense_enabled', {
        is: true,
        then: (schema) => schema.required(t('general_errors.required')),
        otherwise: (schema) => schema.nullable()
      })
  });

export default CampaignSchema;
